import React from 'react';
import {Button, TableCell, TableRow} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';
import SessionInfo from './SessionInfo';
import SessionTileStat from './SessionTileStat';
import {SessionDetail, SessionTag} from '../../interfaces';
import {getComparisonFromStatDifference} from '../../services/measurementService';

interface Props {
  type: string;
  startTime: Date;
  endTime: Date;
  participation: number;
  teamSize?: number;
  detailLink: string;
  sessionTags?: SessionTag[];
  energyRatioForward?: string | null;
  energyRatioForwardBaseline: string | null;
  energyRatioDefense?: string | null;
  energyRatioDefenseBaseline: string | null;
  localDisplayStartTime?: string;
  hasVideo?: boolean;
  hasPendingPlayerSessions?: boolean;
  sessionDetail?: SessionDetail;
  timezone?: string;
}

const TeamSessionListItem: React.FC<Props> = ({
  type,
  startTime,
  endTime,
  sessionDetail,
  participation,
  teamSize,
  detailLink,
  sessionTags,
  energyRatioForward,
  energyRatioForwardBaseline,
  energyRatioDefense,
  energyRatioDefenseBaseline,
  localDisplayStartTime,
  hasVideo,
  hasPendingPlayerSessions,
  timezone,
}) => {
  const {t} = useTranslation();
  const sessionTag = sessionTags?.length ? sessionTags[0].name : '';
  const typeText = `${type || ''}${type && sessionTag ? ' - ' : ''}${sessionTag || ''}`;

  return (
    <TableRow>
      <TableCell>
        <SessionInfo
          type={typeText}
          startTime={startTime}
          endTime={endTime}
          localDisplayStartTime={localDisplayStartTime}
          hasVideo={hasVideo}
          hasPendingPlayerSessions={hasPendingPlayerSessions}
          sessionDetail={sessionDetail}
          timezone={timezone}
        />
      </TableCell>
      <TableCell>
        <SessionTileStat
          label={t('teamSession.energyRatioForwardLabel') as string}
          value={energyRatioForward ?? '--'}
          comparison={getComparisonFromStatDifference(
            energyRatioForwardBaseline ?? undefined,
          )}
          statDifference={energyRatioForwardBaseline}
        />
      </TableCell>
      <TableCell>
        <SessionTileStat
          label={t('teamSession.energyRatioDefenseLabel') as string}
          value={energyRatioDefense ?? '--'}
          comparison={getComparisonFromStatDifference(
            energyRatioDefenseBaseline ?? undefined,
          )}
          statDifference={energyRatioDefenseBaseline}
        />
      </TableCell>
      <TableCell>
        <SessionTileStat
          label={t('teamSession.participation') as string}
          value={`${participation}${teamSize ? `/${teamSize}` : ''}`}
        />
      </TableCell>
      <TableCell align="right">
        <Button component={NavLink} to={detailLink}>
          {t('general.details')}
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default TeamSessionListItem;
